/* eslint-disable */
import { action, observable, runInAction } from 'mobx'
import * as _ from 'lodash'
import { message } from 'antd'
import { isMobile } from 'react-device-detect'
import io from 'socket.io-client'

import { StoreExt } from '@utils/reactExt'
import {
  authStore,
  bettingHistoryStore,
  globalStore,
  messageStore,
  portalSocketStore,
  userPickStore,
  userStore,
} from '@store/index'
import { CHAT_TAB_INDEX, CHAT_TAB_INDEX_KEY } from '@constants/index'
import {
  CHAT_SOCKET_EVENT,
  ChatCheerForTeamDetailType,
  ChatMessageState,
  ChatMessageType,
  ChattingOptions,
  Schema$ChatMessage,
  SimpleChatUserInfo,
  SimpleEmoticonInfo,
  SimpleMatchTimeline,
  SimpleMatchTimelineGroup,
  VisibleUserInfo,
} from '@interface/chat'
import { schema_chat_message } from 'adv-lib/src/models/chat/chat-message/chat-message'
import { EXCEPTIONAL_UNIQUE_ID, FROM_VIEW_TYPE, GlobalStoreKey } from '@v2/constants/common'
import { schema_chat_emoticon } from 'adv-lib/src/models/chat/chat-emoticon'
import { schema_user_chat_option } from 'adv-lib/src/models/chat/user-chat-option'
import { MATCH_GAME_STATUS, MATCH_STATUS, PROPERTY_ID, SPORT_ID } from 'adv-protocol/src/GameCommon'
import { isEmptyList } from '@game/util'
import StorageUtils from '@utils/storage-utils'
import { MESSAGE_ITEM_ORIGIN } from '@interface/common'
import dayjs from 'dayjs'
import {
  lockHtmlOverscroll,
  populateSimpleMatchTimelineGroupToSimpleMatchTimeline,
  unlockHtmlOverscroll,
} from '@utils/utils'
import { PORTAL_SOCKET_EVENT } from '@protocol/socket'
import {
  CHEER_FOR_TEAM_MATCH_SUB_TYPE,
  CHEER_FOR_TEAM_MATCH_TYPE,
  IGetCheerForTeamMatchList,
  Schema$CheerForTeamData,
} from '@protocol/chat'
import matchupStore from '@store/matchupStore'
import { USER_ACTIVITY_TYPE } from '@v2/constants/activity'
import { CHEER_FOR_TEAM_CONTENTS_TYPE } from '@v2/constants/cheer'
import { ChatFloodControlOptions } from '@interface/global-value'

export interface RegisteredMatchTimelineData {
  matchTimeline: SimpleMatchTimeline
  showFullTime: boolean
  endedMatch?: boolean
}

export interface RegisteredMatchTimelineMap {
  [userId: string]: RegisteredMatchTimelineData[]
}

export interface DeletedMatchTimelineMatchIdMap {
  [userId: string]: number[]
}

type ChatSocketErrorType = { status: string, message: string }

export class ChattingStore extends StoreExt {

  chatSocket: SocketIOClient.Socket

  @observable
  isVisibleChatContent = false

  @observable
  originalChatMessageList: Schema$ChatMessage[]

  @observable
  originalAllChatMessageList: Schema$ChatMessage[]

  @observable
  originalReplyChatMessageList: Schema$ChatMessage[]

  @observable
  originalBetHistoryChatMessageList: Schema$ChatMessage[]

  @observable
  allChatMessageList: Schema$ChatMessage[]

  @observable
  replyChatMessageList: Schema$ChatMessage[]

  @observable
  shardBetHistoryChatMessageList: Schema$ChatMessage[]

  @observable
  uploadedImageSrc: string

  @observable
  isVisibleChattingModal = false

  @observable
  selectedEmoticonUrl: string

  @observable
  currentTabIndexKey = CHAT_TAB_INDEX_KEY.ALL

  @observable
  replyToUser: SimpleChatUserInfo

  @observable
  visibleReplyPopoverKey: string

  @observable
  chatAreaScrolledToBottom = {
    [CHAT_TAB_INDEX_KEY.ALL]: true,
    [CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE]: true,
    [CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY]: true,
  }

  @observable
  chatMessageSending = false

  @observable
  newChatMessage: Schema$ChatMessage

  @observable
  isChatEnabled = false

  @observable
  chattingOptions: ChattingOptions

  @observable
  emoticonList = [] as SimpleEmoticonInfo[]

  chatEmoticonList = [] as Partial<schema_chat_emoticon>[]

  @observable
  chatMessageTotalLimit = 100 // 저장될 전체 메시지 갯수.

  @observable
  chatMessageListLimit = 20 // 한번에 로드할 메시지 갯수.

  chatSocketInitialized = false

  @observable
  errorMessage: string

  initializeAllMessageList = false

  @observable
  userChatOptions: Partial<schema_user_chat_option>

  @observable
  favoriteUserListObject = [] as SimpleChatUserInfo[]

  @observable
  blockUserListObject = [] as SimpleChatUserInfo[]

  visibleUserInfo = {} as VisibleUserInfo

  @observable
  liveMatchTimelineGroupList = [] as SimpleMatchTimelineGroup[]

  @observable
  endedMatchTimelineGroupList = [] as SimpleMatchTimelineGroup[]

  @observable
  selectedMatchTimeline: SimpleMatchTimeline

  @observable
  registeredMatchTimelineList: RegisteredMatchTimelineData[]

  @observable
  chatBlockUserIds: string[] = []

  matchIdListToAdd = []

  chatSocketClosed = false

  chatAreaScrollToBottomTimer = null

  updateChatAreaScrollTimer = null

  @observable
  cheerForTeamMatchList: Schema$CheerForTeamData[] = []

  @observable
  cheerForTeamMatchTotalCountPerTab = {
    myBet: 0, favorite: 0, live: 0,
  }

  @observable
  cheerForTeamMatchListPageNum = 1

  @observable
  cheerForTeamMatchListHasMore = false

  @observable
  selectedCheerForTeamItem: Schema$CheerForTeamData = null

  @observable
  currentCheerForTeamType: CHEER_FOR_TEAM_MATCH_TYPE = CHEER_FOR_TEAM_MATCH_TYPE.MY_BET

  @observable
  currentCheerForTeamSubType: CHEER_FOR_TEAM_MATCH_SUB_TYPE = CHEER_FOR_TEAM_MATCH_SUB_TYPE.ONGOING

  @observable
  isCheerForTeamFirstSearch = true

  @observable
  mySharedBetHistoryChatMessage: Schema$ChatMessage[]

  @observable
  isVisibleCheerForTeamPanel = false

  chatMessageIdOnChatClosed: number // 채팅창이 닫혔을때 등록된 응원글의 chatMessageId

  myRecentChatQueue = []

  constructor() {
    super()
    this.reset()
  }

  @action
  async initChatSocket() {
    console.log('[ChattingStore] ==== init chat socket start')
    this.setChattingOptions()
    this.setUserChatOptions()
    this.setupVisibleUserInfo()
    this.isVisibleChatContent = isMobile ? this.isVisibleChattingModal : true

    if (this.chattingOptions.active) {
      console.info('[ChattingStore] ==== chat socket init processing')
      if (!this.chatSocketInitialized) {
        this.chatSocketInitialized = true
        if (!this.chatSocket) {
          await this.makeChatSocket()
          await this.setupChatSocketSubscription()
          this.setupSimpleLiveMatchSubscription()
        }
        console.info('[ChattingStore] ==== chat socket init done.')
      }
    } else {
      await this.disconnectChatSocket()
    }
  }

  @action
  async documentVisibleChangeHandler(isHidden: boolean): Promise<void> {
    if (!isMobile) {
      if (isHidden) {
        await this.publishInvisibleChat()
      } else {
        await this.publishVisibleChat()
        this.getRealTimeLiveScoreMatchIdsByBettingHistory()
      }
      return
    }

    this.isVisibleChatContent = !isHidden

    if (isHidden) {
      if (this.isVisibleChattingModal) {
        await this.publishInvisibleChat()
      }
      await this.disconnectChatSocket(this.isVisibleChattingModal)

    } else {
      await this.initChatSocket()
      if (this.isVisibleChattingModal) {
        await this.publishVisibleChat()
        this.getRealTimeLiveScoreMatchIdsByBettingHistory()
      }
    }
  }

  @action
  setChattingOptions() {
    const chatOption = globalStore.findGlobalSetting(GlobalStoreKey.CHATTING_OPTIONS)
    const chattingOptionsValue = chatOption?.value || '{}'
    this.chattingOptions = JSON.parse(chattingOptionsValue) as ChattingOptions
    this.isChatEnabled = this.chattingOptions.active
    this.chatMessageListLimit = this.chattingOptions.lazyLoadLimit
    this.chatMessageTotalLimit = this.chattingOptions.totalLimit

    if (!authStore.isSignedIn) {
      return
    }

    this.chatEmoticonList = StorageUtils.getChatEmoticonListByVersion(this.chattingOptions.emoticonVersion)
    if (this.chatEmoticonList.length === 0) {
      const emoticonVersion = this.chattingOptions.emoticonVersion
      this.api.chat.getEmoticonList({ version: emoticonVersion }).then(response => {
        this.chatEmoticonList = [].concat(response.result)
        StorageUtils.saveChatEmoticonListByVersion(emoticonVersion, this.chatEmoticonList)
        this.updateSimpleEmoticonList()
      })
    } else {
      this.updateSimpleEmoticonList()
    }
  }

  updateSimpleEmoticonList() {
    runInAction(() => { // @action 이 없는 외부에서 호출시 emoticonList 수정사항이 전파가 안되는 현상 해결.
      const simpleEmoticonList = []
      for (const emoticon of this.chatEmoticonList) {
        simpleEmoticonList.push({ img: emoticon.urlSuffix, pvImg: emoticon.previewUrlSuffix })
      }
      this.emoticonList = [].concat(simpleEmoticonList)
    })
  }

  @action
  setUserChatOptions() {
    if (!authStore.isSignedIn) {
      return
    }

    this.userChatOptions = authStore.userInfo.chatOption
    this.parsingFavoriteAndBlockUserList()
  }

  @action
  async disconnectChatSocket(modalVisible = false) {
    try {
      console.info(`[ChattingStore] chat socket disconnect processing. initialized: ${this.chatSocketInitialized}, socket: ${this.chatSocket}`)
      if (this.chatSocketInitialized && this.chatSocket) {
        this.chatSocketInitialized = false
        this.chatSocketClosed = false
        await this.changeChattingModalVisible(modalVisible)
        this.chatSocketPreDisconnect()
        this.chatSocket.disconnect()
        console.info('[ChattingStore] chat socket disconnected')
        this.chatSocket = null
      }
    } catch (err) {
      console.error(err)
    }
  }

  @action
  reset() {
    console.info('[ChattingStore] reset processing.')
    this.clearAllMessage()
    this.clearState()

    this.currentTabIndexKey = CHAT_TAB_INDEX_KEY.ALL
    this.chatAreaScrolledToBottom = {
      [CHAT_TAB_INDEX_KEY.ALL]: true,
      [CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE]: true,
      [CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY]: true,
    }
  }

  @action
  setupVisibleUserInfo() {
    this.visibleUserInfo = null
    if (authStore.isSignedIn) {
      this.visibleUserInfo = {
        userId: authStore?.userInfo.id,
        userNick: authStore?.userInfo.nick,
        mobile: isMobile,
      }
    }
  }

  async makeChatSocket(): Promise<void> {
    const url = `${process.env.CHAT_SOCKET_BASE_URL}`
    console.log('==== chat socket url', url)
    this.chatSocket = io(url, {
      transports: ['websocket', 'polling'],
    })
  }

  async setupChatSocketSubscription(isDisconnected = false) {
    if (_.isNil(this.chatSocket)) {
      return
    }
    if (isDisconnected) {
      this.chatSocket.removeAllListeners()
    } else {
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_CONNECTED, () => this.onChatSocketConnected())
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_DISCONNECTED, () => this.onChatSocketDisconnected())
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_CONNECT_ERROR, (data: Schema$ChatMessage) => this.onChatSocketConnectError(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.RECONNECT, (data: Schema$ChatMessage) => this.onChatSocketReconnectByServer(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.RECONNECTION_ATTEMPT, (data: Schema$ChatMessage) => this.onChatSocketReconnectionAttemptByServer(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_RECONNECT, (data: Schema$ChatMessage) => this.onChatSocketReconnect(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_RECONNECTION_ATTEMPT, (data: Schema$ChatMessage) => this.onChatSocketReconnectionAttempt(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_CHAT_MESSAGE, (data: Schema$ChatMessage) => this.onChatMessageHandler(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_ALL_CHAT_MESSAGE, (data: Schema$ChatMessage) => this.onAllChatMessageHandler(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_ALL_MY_REPLY_MESSAGE, (data: Schema$ChatMessage) => this.onAllMyReplyMessage(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_ALL_SHARED_BET_HISTORY_MESSAGE, (data: Schema$ChatMessage) => this.onAllSharedBetHistoryMessage(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_UPDATE_CHAT_MESSAGE, (data: Schema$ChatMessage) => this.onUpdateChatMessage(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_PRE_DISCONNECT, (data: Schema$ChatMessage) => this.onPreDisconnectChatSocketHandler(data))
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_EXCEPTION, (data: ChatSocketErrorType) => this.onChatSocketException(data))
    }
  }

  setupSimpleLiveMatchSubscription(disconnect = false) {
    if (disconnect) {
      this.chatSocket.off(CHAT_SOCKET_EVENT.ON_ENDED_SIMPLE_MATCH_LIST)
    } else if (isMobile && this.isVisibleChattingModal) {
      this.chatSocket.on(CHAT_SOCKET_EVENT.ON_ENDED_SIMPLE_MATCH_LIST, data => this.onEndedSimpleMatchTimelineGroupListHandler(data))
    }
  }

  chatSocketPreDisconnect() {
    if (!authStore.isSignedIn || !this.visibleUserInfo) {
      return
    }
    this.chatSocket.emit(CHAT_SOCKET_EVENT.PRE_DISCONNECT, this.visibleUserInfo)
  }

  @action
  async getAllChatMessages() {
    await this.checkChatSocketConnectionState()
    this.chatSocket.emit(CHAT_SOCKET_EVENT.GET_ALL_CHAT_MESSAGE, { userId: authStore?.userInfo?.id })
  }

  @action
  async checkChatSocketConnectionState() {
    if (this.chatSocket && this.chatSocketClosed) {
      console.info('[ChattingStore] checkSocketConnectionState disconnect processing')
      await this.disconnectChatSocket(this.isVisibleChattingModal)
      await this.initChatSocket()
    }
  }

  @action
  async getAllMyReplyChatMessage() {
    if (!authStore.isSignedIn) {
      return
    }
    console.info(`[ChattingStore] getAllMyReplyChatMessage send: ${JSON.stringify({ userId: authStore?.userInfo.id })}`)
    await this.checkChatSocketConnectionState()
    this.chatSocket.emit(CHAT_SOCKET_EVENT.GET_ALL_MY_REPLY_MESSAGE, { userId: authStore?.userInfo.id })
  }

  @action
  async getAllBetHistoryChatMessage() {
    await this.checkChatSocketConnectionState()
    this.chatSocket.emit(CHAT_SOCKET_EVENT.GET_ALL_SHARED_BET_HISTORY_MESSAGE, { userId: authStore?.userInfo?.id })
  }

  @action
  onChatMessageHandler(data: Schema$ChatMessage) {
    // 로그인한 상태 일 때 차단한 유저 메시지가 오면 추가하지 않도록 예외처리
    if (authStore.isSignedIn
      && _.includes(this.chatBlockUserIds, data.fromUserId)) {
      return
    }

    // called when the client receives a STOMP message from the server
    if (data && this.chattingOptions.active) {
      console.info(`[ChattingStore] got message with body ${JSON.stringify(data)}`)

      if (data.fromUserId !== authStore?.userInfo?.id) {
        data.activityInfoList = []
      }

      this.addChatMessage(data)
      this.addMyRecentChat(data)
    }
  }

  onChatSocketConnected() {
    console.log('==== chat socket connection success', this.chatSocket)
    this.reset()
    if (isMobile) {
      if (this.isVisibleChattingModal) {
        this.publishVisibleChat().catch(console.error)
        this.getRealTimeLiveScoreMatchIdsByBettingHistory()
      } else {
        this.publishInvisibleChat().catch(console.error)
      }
    } else {
      this.publishVisibleChat().catch(console.error)
    }

    this.getAllChatMessages().catch(console.error)
    this.getAllMyReplyChatMessage().catch(console.error)
    this.getAllBetHistoryChatMessage().catch(console.error)
    this.initializeAllMessageList = true
  }

  resetAllMessage() {
    this.clearAllMessage()

    this.getAllChatMessages().catch(console.error)
    this.getAllMyReplyChatMessage().catch(console.error)
    this.getAllBetHistoryChatMessage().catch(console.error)
  }

  async onChatSocketDisconnected() {
    console.log('==== chat socket disconnection success')
    await this.setupChatSocketSubscription(true)
    this.chatSocketClosed = true
  }

  onChatSocketConnectError(data) {
    console.log('==== chat socket connect error', data)
    this.chatSocketClosed = true
  }

  onChatSocketReconnect(data) {
    console.log('==== chat socket reconnect', data)
  }

  onChatSocketReconnectionAttempt(data) {
    console.log('==== chat socket reconnection attempt', data)
  }

  onChatSocketReconnectByServer(data) {
    console.log('==== chat socket reconnect by server', data)
  }

  onChatSocketReconnectionAttemptByServer(data) {
    console.log('==== chat socket reconnection attempt by server', data)
  }

  @action
  async uploadImage(imageFile): Promise<string> {
    console.info(`[ChattingStore] uploadImage send: ${JSON.stringify(imageFile)}`)
    this.clearUploadedImageSrc()
    const response = await this.api.v2.uploadChatImageFile(imageFile)
    this.onUploadedImageHandler(response.data)
    return response.data
  }

  @action
  async uploadProfileImage(imageFile): Promise<string> {
    console.info(`[ChattingStore] uploadUserProfileImage send: ${JSON.stringify(imageFile)}`)
    this.clearUploadedImageSrc()
    const response = await this.api.v2.uploadUserProfileImageFile(imageFile)
    return response.data
  }

  @action
  onAllChatMessageHandler(data: Schema$ChatMessage) {
    this.originalChatMessageList = _.concat([], data)
    this.originalAllChatMessageList = _.concat([], data)

    if (authStore.isSignedIn) {
      const userPromiseId = authStore.userInfo.id
      this.myRecentChatQueue = _.filter(data, { fromUserId: userPromiseId })
    }

    this.lazyLoadAllChatMessageList()
  }

  @action
  onAllMyReplyMessage(data: Schema$ChatMessage) {
    this.originalReplyChatMessageList = _.concat([], data)
    this.lazyLoadReplyChatMessageList()
  }

  @action
  onAllSharedBetHistoryMessage(data: Schema$ChatMessage) {
    this.originalBetHistoryChatMessageList = _.concat([], data)
    this.lazyLoadBetHistoryChatMessageList()
  }

  @action
  onUpdateChatMessage(chatMessage: Schema$ChatMessage) {
    const { chatId } = chatMessage
    const allIdx = _.findIndex(this.allChatMessageList, { chatId })
    const replyIdx = _.findIndex(this.replyChatMessageList, { chatId })
    const betHistoryIdx = _.findIndex(this.shardBetHistoryChatMessageList, { chatId })

    const oriIdx = _.findIndex(this.originalChatMessageList, { chatId })
    const oriAllIdx = _.findIndex(this.originalAllChatMessageList, { chatId })
    const oriReplyIdx = _.findIndex(this.originalReplyChatMessageList, { chatId })
    const oriBetHistoryIdx = _.findIndex(this.originalBetHistoryChatMessageList, { chatId })

    if (oriIdx > -1) {
      this.originalChatMessageList[oriIdx] = chatMessage
    }
    if (oriAllIdx > -1) {
      this.originalAllChatMessageList[oriAllIdx] = chatMessage
    }
    if (oriReplyIdx > -1) {
      this.originalReplyChatMessageList[oriReplyIdx] = chatMessage
    }
    if (oriBetHistoryIdx > -1) {
      this.originalBetHistoryChatMessageList[oriBetHistoryIdx] = chatMessage
    }

    const isDisabledMessage = chatMessage.state === ChatMessageState.DISABLE
    if (allIdx > -1) {
      this.allChatMessageList[allIdx] = chatMessage
      if (isDisabledMessage && !this.isExceedMinimumEnabledChatMessageCount(this.allChatMessageList)) {
        this.lazyLoadAllChatMessageList()
      }
    }
    if (replyIdx > -1) {
      this.replyChatMessageList[replyIdx] = chatMessage
      if (isDisabledMessage && !this.isExceedMinimumEnabledChatMessageCount(this.replyChatMessageList)) {
        this.lazyLoadReplyChatMessageList()
      }
    }
    if (betHistoryIdx > -1) {
      this.shardBetHistoryChatMessageList[betHistoryIdx] = chatMessage
      if (isDisabledMessage && !this.isExceedMinimumEnabledChatMessageCount(this.shardBetHistoryChatMessageList)) {
        this.lazyLoadBetHistoryChatMessageList()
      }
    }
  }

  isExceedMinimumEnabledChatMessageCount(chatMessageList: Schema$ChatMessage[]): boolean {
    const enabledCount = _.chain(chatMessageList).filter(message => {
      return message.state === ChatMessageState.ENABLE
    }).size().value()
    // 최소한 페이징 처리 데이터 수의 반 이상은 표시할 수 있어야 한다 (채팅 목록에 스크롤이 생길 수 있다.)
    return enabledCount >= (this.chatMessageListLimit / 2)
  }

  @action
  onChatErrorMessage(data) {
    const error = JSON.parse(data.body)
    this.setChatErrorMessage(error.errorMessage)
  }

  onChatSocketException(error: ChatSocketErrorType) {
    this.setChatErrorMessage(error.message)
  }

  @action
  setChatErrorMessage(errorMessage) {
    this.errorMessage = errorMessage
  }

  @action
  lazyLoadAllChatMessageList() {
    const messageList = this.lazyLoadChatMessageList(this.allChatMessageList, this.originalAllChatMessageList)
    if (!_.isEmpty(messageList)) {
      this.allChatMessageList = _.chain(messageList).uniqBy('chatId').orderBy(['id'], ['asc']).concat([]).value()
    }
  }

  @action
  lazyLoadReplyChatMessageList() {
    const messageList = this.lazyLoadChatMessageList(this.replyChatMessageList, this.originalReplyChatMessageList)
    if (!_.isEmpty(messageList)) {
      this.replyChatMessageList = [].concat(messageList)
    }
  }

  @action
  lazyLoadBetHistoryChatMessageList() {
    const messageList = this.lazyLoadChatMessageList(this.shardBetHistoryChatMessageList, this.originalBetHistoryChatMessageList)
    if (!_.isEmpty(messageList)) {
      this.shardBetHistoryChatMessageList = [].concat(messageList)
    }
  }

  @action
  lazyLoadChatMessageList(chatMessageList: Schema$ChatMessage[], originalChatMessageList: Schema$ChatMessage[]): Schema$ChatMessage[] {
    if (_.size(originalChatMessageList) > 0) {
      let sliceStart = 0
      if (_.size(originalChatMessageList) >= this.chatMessageListLimit) {
        sliceStart = _.size(originalChatMessageList) - this.chatMessageListLimit
      }

      let resultChatMessageList
      if (_.size(chatMessageList) > 0) {
        resultChatMessageList = _.concat(originalChatMessageList.splice(sliceStart), chatMessageList)
      } else {
        resultChatMessageList = _.concat(chatMessageList, originalChatMessageList.splice(sliceStart))
      }

      if (!this.isExceedMinimumEnabledChatMessageCount(resultChatMessageList)) {
        let result = this.lazyLoadChatMessageList(resultChatMessageList, originalChatMessageList)
        if (result) {
          resultChatMessageList = result
        }
      }
      return resultChatMessageList
    }

    return undefined
  }

  getChattingListScrollTop(): number {
    return document.querySelector('#chatWrap .am-tabs-pane-wrap').scrollTop
  }

  @action
  hasMoreAllChatMessageList() {
    return _.size(this.originalAllChatMessageList) > 0
  }

  @action
  hasMoreReplyChatMessageList() {
    return _.size(this.originalReplyChatMessageList) > 0
  }

  @action
  hasMoreBetHistoryChatMessageList() {
    return _.size(this.originalBetHistoryChatMessageList) > 0
  }

  @action
  onUploadedImageHandler(data): void {
    this.uploadedImageSrc = data
  }

  onPreDisconnectChatSocketHandler(data) {
    console.info('==== on chat socket pre disconnected', data)
  }

  @action
  async getEndedMatchTimelineGroupList(matchIdList: number[]): Promise<void> {
    this.chatSocket.emit(CHAT_SOCKET_EVENT.GET_ENDED_SIMPLE_MATCH_GROUP_LIST, matchIdList)
  }

  @action
  async onEndedSimpleMatchTimelineGroupListHandler(data: SimpleMatchTimelineGroup[] = []): Promise<void> {
    populateSimpleMatchTimelineGroupToSimpleMatchTimeline(data)
    this.endedMatchTimelineGroupList = [].concat(data)
    const result = await this.refreshAndGetRegisteredMatchTimelineData()

    // 개발목적으로 과거 종료된 매치의 스코어를 확인하고 싶다면 아래의 함수를 호출하게 변경하면된다.
    // 스코어는 하나만 남겨 두고 확인 해야 한다. 설정시 어떤 스코어든 상관없고 아래의 매치 아이디의 스코어로 대체 된다.
    // const result = this.refreshAndGetRegisteredMatchTimelineData2(25824490)
    this.setRegisteredMatchTimelineList(result)
  }

  @action
  async onSimpleMatchTimelineGroupListHandler(data: SimpleMatchTimelineGroup[] = []): Promise<void> {
    populateSimpleMatchTimelineGroupToSimpleMatchTimeline(data)
    this.liveMatchTimelineGroupList = [].concat(data)

    _.forEach(this.matchIdListToAdd, matchId => {
      this.registerMatchTimelineWatchingListByBettingHistory(matchId)
    })
    this.matchIdListToAdd = []

    const result = await this.refreshAndGetRegisteredMatchTimelineData()

    // 개발목적으로 과거 종료된 매치의 스코어를 확인하고 싶다면 아래의 함수를 호출하게 변경하면된다.
    // 스코어는 하나만 남겨 두고 확인 해야 한다. 설정시 어떤 스코어든 상관없고 아래의 매치 아이디의 스코어로 대체 된다.
    // 파라메터로 확인하고자 하는 매치의 아이디를 넘겨 주면된다.
    // const result = this.refreshAndGetRegisteredMatchTimelineData2(25824490)
    this.setRegisteredMatchTimelineList(result)
  }

  @action
  async refreshAndGetRegisteredMatchTimelineData(): Promise<RegisteredMatchTimelineData[]> {
    this.deleteExpiredEndedMatches()

    const userId = authStore.userInfo.id
    const registeredMatchTimelineListData = StorageUtils.getTimelineMatchIdList()
    const timelineMatchData: RegisteredMatchTimelineData[] = []
    let timelineListMap: RegisteredMatchTimelineMap = {}
    if (registeredMatchTimelineListData) {
      timelineListMap = registeredMatchTimelineListData
      const registeredData = timelineListMap[userId] || []
      registeredData.forEach(data => timelineMatchData.push(data))
    }

    if (!_.isEmpty(timelineMatchData)) {
      let filteredList: RegisteredMatchTimelineData[] = []
      let notExistsTimelineList = []
      for (const timelineData of timelineMatchData) {
        const { matchTimeline, showFullTime, endedMatch } = timelineData
        if (endedMatch || !matchTimeline) {
          filteredList.push(timelineData)
          continue
        }
        if (!matchTimeline) {
          continue
        }
        let exists = false
        _.forEach(this.liveMatchTimelineGroupList, group => {
          const existsItem = _.find(group.simpleMatchTimelineList, { matchId: matchTimeline.matchId })
          if (existsItem) {
            filteredList.push({ matchTimeline: existsItem, showFullTime })
            exists = true
          }
        })
        if (!exists) {
          _.forEach(this.endedMatchTimelineGroupList, group => {
            const existsItem = _.find(group.simpleMatchTimelineList, { matchId: matchTimeline.matchId })
            if (existsItem && (existsItem.matchStatusCode === MATCH_STATUS.Ended || existsItem.statusCode === MATCH_GAME_STATUS.Closed) && !_.isEmpty(existsItem.matchEndedAt)) {
              filteredList.push({ matchTimeline: existsItem, showFullTime, endedMatch: true })
              exists = true
            }
          })
        }
        if (!exists) {
          notExistsTimelineList.push(timelineData)
          filteredList.push(timelineData)
        }
      }

      if (!_.isEmpty(notExistsTimelineList)) {
        await this.getEndedMatchTimelineGroupList(_.map(notExistsTimelineList, data => data.matchTimeline.matchId))
      }
      timelineListMap[userId] = [].concat(filteredList)
      StorageUtils.saveTimelineMatchIdList(timelineListMap)
      return filteredList
    }
    return null
  }

  // 과거 매치의 스코어를 확인하고 싶다면 아래의 함수를 호출하게 변경하면된다.
  // 스코어는 하나만 남겨 두고 확인 해야 한다.
  @action
  async refreshAndGetRegisteredMatchTimelineData2(checkMatchId: number) {
    const userId = authStore.userInfo.id
    const registeredMatchTimelineListData = StorageUtils.getTimelineMatchIdList()
    const timelineMatchData: RegisteredMatchTimelineData[] = []
    let timelineListMap: RegisteredMatchTimelineMap = {}
    if (registeredMatchTimelineListData) {
      timelineListMap = registeredMatchTimelineListData
      const registeredData = timelineListMap[userId] || []
      registeredData.forEach(data => timelineMatchData.push(data))
    }

    if (!_.isEmpty(timelineMatchData)) {
      let filteredList = []
      let notExistsTimelineList = []
      for (const timelineData of timelineMatchData) {
        const { matchTimeline, showFullTime, endedMatch } = timelineData
        // if (endedMatch || !matchTimeline) {
        //   filteredList.push(timelineData)
        //   continue
        // }
        if (!matchTimeline) {
          continue
        }
        let exists = false
        _.forEach(this.liveMatchTimelineGroupList, group => {
          const existsItem = _.find(group.simpleMatchTimelineList, { matchId: matchTimeline.matchId })
          if (existsItem) {
            filteredList.push({ matchTimeline: existsItem, showFullTime })
            exists = true
          }
        })
        if (!exists) {
          _.forEach(this.endedMatchTimelineGroupList, group => {
            const existsItem = _.find(group.simpleMatchTimelineList, { matchId: checkMatchId }) // matchTimeline.matchId })
            if (existsItem && (existsItem.matchStatusCode === MATCH_STATUS.Ended || existsItem.statusCode === MATCH_GAME_STATUS.Closed)) {
              filteredList.push({ matchTimeline: existsItem, showFullTime, endedMatch: true })
              exists = true
            }
          })
        }
        if (!exists) {
          notExistsTimelineList.push(timelineData)
          filteredList.push(timelineData)
        }
      }

      if (!_.isEmpty(notExistsTimelineList)) {
        await this.getEndedMatchTimelineGroupList([checkMatchId]) // _.map(notExistsTimelineList, data => data.matchTimeline.matchId))
      }
      timelineListMap[userId] = [].concat(filteredList)
      StorageUtils.saveTimelineMatchIdList(timelineListMap)
      return filteredList
    }
    return null
  }

  private sortRegisteredMatchTimelineList(timelineList: RegisteredMatchTimelineData[]): RegisteredMatchTimelineData[] {
    return _.orderBy(timelineList, [
      timeline => new Date(timeline.matchTimeline?.dateOfMatch),
      'matchTimeline.matchId',
    ], ['desc', 'asc'])
  }

  @action
  async setRegisteredMatchTimelineList(selectedTimelineList?: RegisteredMatchTimelineData[]) {
    if (selectedTimelineList) {
      this.registeredMatchTimelineList = this.sortRegisteredMatchTimelineList(selectedTimelineList)
    } else {
      const savedItems = await this.refreshAndGetRegisteredMatchTimelineData()
      if (savedItems) {
        this.registeredMatchTimelineList = this.sortRegisteredMatchTimelineList(savedItems)
      }
    }
  }

  registerMatchTimelineWatchingListByBettingHistory(matchId: number): void {
    if (_.isEmpty(this.liveMatchTimelineGroupList)) {
      this.matchIdListToAdd = _.concat(this.matchIdListToAdd, [matchId])
    } else {
      const timelineMap = this.getLiveMatchTimeLineMatchIdAndTimelineMap()
      const timeline = timelineMap?.[matchId]
      if (_.isEmpty(timeline)) {
        this.matchIdListToAdd.push(matchId)
      } else {
        if (this.existRegisteredTimelineMatchIdByUser(timeline.matchId)) {
          return
        }

        let showFullTime = true
        if (timeline.sportId === SPORT_ID.VOLLEYBALL
          || timeline.sportId === SPORT_ID.TENNIS
          || timeline.sportId === SPORT_ID.TABLE_TENNIS) {
          showFullTime = false
        }
        this.registerMatchTimelineWatchingList(timeline, showFullTime)
      }
    }
  }

  @action
  registerMatchTimelineWatchingList(selectedMatchTimeline: SimpleMatchTimeline, showFullTime: boolean) {
    if (!selectedMatchTimeline) {
      return
    }
    const userId = authStore.userInfo.id
    const registeredMatchTimelineListData = StorageUtils.getTimelineMatchIdList()
    let timelineListMap: RegisteredMatchTimelineMap
    if (registeredMatchTimelineListData) {
      timelineListMap = registeredMatchTimelineListData
      const timelineDataList = timelineListMap[userId]
      if (isEmptyList(timelineDataList)) {
        timelineListMap[userId] = [].concat([{ matchTimeline: selectedMatchTimeline, showFullTime }])
      } else {
        let added = false
        for (const item of timelineListMap[userId]) {
          if (_.isNil(item.matchTimeline) || (item.matchTimeline.matchId === selectedMatchTimeline.matchId)) {
            item.matchTimeline = selectedMatchTimeline
            item.showFullTime = showFullTime
            added = true
            break
          }
        }
        if (!added) {
          timelineListMap[userId].push({ matchTimeline: selectedMatchTimeline, showFullTime })
        }
      }
    } else {
      timelineListMap = { [userId]: [{ matchTimeline: selectedMatchTimeline, showFullTime }] }
    }

    const maxCount
      = globalStore.findGlobalSetting(GlobalStoreKey.REAL_TIME_SCORE_MAX_REGISTRATION_COUNT)?.value || 10
    if (_.size(timelineListMap[userId]) > Number(maxCount)) {
      return
    }

    timelineListMap[userId] = _.sortBy(timelineListMap[userId], ['matchTimeline.dateOfMatch', 'matchTimeline.matchId'], ['desc', 'asc'])
    StorageUtils.saveTimelineMatchIdList(timelineListMap)
    this.setRegisteredMatchTimelineList(timelineListMap[userId])
  }

  @action
  changeSelectedMatchTimeline(selectedMatchTimeline: SimpleMatchTimeline) {
    this.selectedMatchTimeline = selectedMatchTimeline
  }

  @action
  cleanRegisteredMatchTimelineData() {
    const userId = authStore.userInfo.id
    const registeredMatchTimelineListData = StorageUtils.getTimelineMatchIdList()
    if (registeredMatchTimelineListData) {
      const data = registeredMatchTimelineListData
      const myData = data[userId]
      if (!_.isEmpty(myData)) {
        delete data[userId]
        if (_.isEmpty(data)) {
          StorageUtils.removeTimelineMatchIdList()
        } else {
          StorageUtils.saveTimelineMatchIdList(data)
        }
      }
    }
    this.registeredMatchTimelineList = []
    this.endedMatchTimelineGroupList = []
  }

  @action
  deleteRegisteredMatchTimelineData(targetMatchId: number, showFullTime: boolean, isEndedMatch = false) {
    const userId = authStore.userInfo.id
    const registeredMatchTimelineListData = StorageUtils.getTimelineMatchIdList()

    if (_.isEmpty(registeredMatchTimelineListData)) {
      return
    }

    const data = registeredMatchTimelineListData
    if (_.isEmpty(data[userId])) {
      return
    }

    const deletedData = StorageUtils.getDeletedTimelineMatchIdList() ?? {}
    if (isEndedMatch) {
      const deletedMatchIds = deletedData?.[userId] ?? []
      deletedData[userId] = _.pull(deletedMatchIds, targetMatchId)
    } else {
      deletedData[userId] = _.concat(deletedData?.[userId] ?? [], [targetMatchId])
    }

    StorageUtils.saveDeletedTimeLineMatchIdList(deletedData)

    let endedMatch = false
    _.forEach(data[userId], item => {
      if (item.endedMatch) {
        endedMatch = true
      }
      if (item.matchTimeline?.matchId === targetMatchId && item.showFullTime === showFullTime) {
        delete item.matchTimeline
        delete item.showFullTime
        delete item.endedMatch
      }
    })
    if (isEmptyList(data[userId])) {
      delete data[userId]
    }
    if (_.isEmpty(data)) {
      StorageUtils.removeTimelineMatchIdList()
      this.registeredMatchTimelineList = []
      this.endedMatchTimelineGroupList = []
    } else {
      StorageUtils.saveTimelineMatchIdList(data)
      if (isEmptyList(data[userId])) {
        this.registeredMatchTimelineList = []
        this.endedMatchTimelineGroupList = []
      } else {
        this.registeredMatchTimelineList = [].concat(data[userId])
        if (endedMatch) {
          _.forEach(this.endedMatchTimelineGroupList, group => {
            _.remove(group.simpleMatchTimelineList, timeline => {
              return timeline.matchId === targetMatchId
            })
            if (_.isEmpty(group.simpleMatchTimelineList)) {
              delete group.simpleMatchTimelineList
            }
          })
        }
      }
    }
  }

  @action
  clearUploadedImageSrc() {
    this.uploadedImageSrc = null
  }

  @action
  clearState() {
    this.uploadedImageSrc = null
    this.selectedEmoticonUrl = null
    this.replyToUser = null
    this.newChatMessage = null
    this.chatSocketClosed = null

    messageStore?.setReceiveUser(undefined)
  }

  @action
  clearAllMessage() {
    this.originalChatMessageList = []

    this.originalAllChatMessageList = []
    this.originalReplyChatMessageList = []
    this.originalBetHistoryChatMessageList = []

    this.allChatMessageList = []
    this.replyChatMessageList = []
    this.shardBetHistoryChatMessageList = []

    this.myRecentChatQueue = []

    this.newChatMessage = null
    this.initializeAllMessageList = false
  }

  @action
  async sendChatMessage(contents: string): Promise<void> {
    const nick = authStore.userInfo.nick
    const userId = authStore.userInfo.id
    const avatar = authStore.userInfo.avatar

    let attachment: any
    let attachmentDetail: any
    let chatType = ChatMessageType.TEXT_ONLY
    if (this.uploadedImageSrc) {
      chatType = ChatMessageType.IMAGE
      attachment = this.uploadedImageSrc
    } else if (this.selectedEmoticonUrl) {
      chatType = ChatMessageType.EMOTICON
      attachment = this.selectedEmoticonUrl
    } else if (bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]) {
      chatType = ChatMessageType.BET_HISTORY
      attachment = bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.betId // bettor_bet id
      const sportIdSet = new Set<number>()
      _.forEach(bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.folds, fold => {
        sportIdSet.add(fold.sportId)
      })
      attachmentDetail = {
        bettorBetId: attachment,
        betId: bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.bet.id, // bettor_bet betId (클럽벳 조회용 - 어드민에서사용)
        foldCount: bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.bet.foldCount,
        dividendRate: bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.bet.dividendRate,
        hitState: bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.bet.hitState,
        canceled: bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT]?.bet.canceled,
        sportIds: Array.from<number>(sportIdSet), // 중복제거된 sportId로 5자리수 sportId 기준 60자 이하 사용
      }
      if (bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]) {
        attachmentDetail['displayFolds'] = []
        attachmentDetail['displayFolds'].push({
          foldId: bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]?.foldId,
          selectionName: bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]?.selectionName,
          outcomeRate: bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]?.outcomeRate,
          outcomeName: bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]?.marketName,
          specialBetValue: bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]?.specialBetValue,
          hitState: bettingHistoryStore.selectedBettingHistoryFoldData[FROM_VIEW_TYPE.CHAT]?.hitState,
          homeTeamName: bettingHistoryStore.selectedBettingHistoryFold[FROM_VIEW_TYPE.CHAT]?.homeTeamName,
          awayTeamName: bettingHistoryStore.selectedBettingHistoryFold[FROM_VIEW_TYPE.CHAT]?.awayTeamName,
          sportId: bettingHistoryStore.selectedBettingHistoryFold[FROM_VIEW_TYPE.CHAT]?.sportId,
        })
      }
    }

    if (this.selectedCheerForTeamItem) {
      chatType = ChatMessageType.CHEER_FOR_TEAM
      const details: ChatCheerForTeamDetailType = {
        cheerForTeamItem: this.selectedCheerForTeamItem,
        uploadedImageSrc: this.uploadedImageSrc,
        emoticonUrl: this.selectedEmoticonUrl,
        betHistory: null,
      }
      if (bettingHistoryStore.selectedBettingHistory[FROM_VIEW_TYPE.CHAT] && !_.isEmpty(attachmentDetail)) {
        details.betHistory = Object.assign({}, attachmentDetail)
      }
      attachmentDetail = details
    }

    const body = {
      type: chatType,
      fromUserId: userId,
      fromUserNick: nick,
      toUserId: this.replyToUser?.id,
      toUserNick: this.replyToUser?.nick,
      fromUserProfileImg: avatar,
      contents,
      attachment,
      attachmentDetail: !_.isEmpty(attachmentDetail) ? JSON.stringify(attachmentDetail) : null,
      visibleContents: true,
      visibleAttachment: true,
    } as schema_chat_message
    console.info(`[ChattingStore] sendChatMessage send: ${JSON.stringify(body)}`)

    this.chatMessageSending = true
    await this.checkChatSocketConnectionState()
    this.chatSocket.emit(CHAT_SOCKET_EVENT.SEND_CHAT_MESSAGE, body)
  }

  isBlockUserChatMessage(chatMessage: Schema$ChatMessage): boolean {
    return !_.chain(this.blockUserListObject).find({ id: chatMessage.fromUserId }).isNil().value()
  }

  isFavoriteUserChatMessage(chatMessage: Schema$ChatMessage): boolean {
    return !_.chain(this.favoriteUserListObject).find({ id: chatMessage.fromUserId }).isNil().value()
  }

  isShowNewMessage(chatMessage: Schema$ChatMessage): boolean {
    if (authStore.isSignedIn && chatMessage.fromUserId !== MESSAGE_ITEM_ORIGIN.SYSTEM) {
      if (!this.isVisibleCheerForTeamPanel && chatMessage.fromUserId === authStore.userInfo.id) {
        return false
      }
      if (this.isBlockUserChatMessage(chatMessage)) {
        return false
      }

      if (this.userChatOptions?.onlyFavoriteUserMessage && !this.isFavoriteUserChatMessage(chatMessage)) {
        return false
      }
    }
    return true
  }

  isShowNewMessageForBottomModal(chatMessage: Schema$ChatMessage): boolean {
    if (!this.isShowNewMessage(chatMessage)) {
      return false
    }
    if (!this.isVisibleCheerForTeamPanel && this.isChatAreaScrolledToBottom()) {
      return false
    }
    if (isMobile && !this.isVisibleChattingModal) {
      return false
    }

    return true
  }

  isShowNewMessageForToastAlert(chatMessage: Schema$ChatMessage): boolean {
    if (!this.isShowNewMessage(chatMessage)) {
      return false
    }
    if (!authStore.isSignedIn) {
      return false
    }
    if (!this.userChatOptions.showChattingPreviewMainMessage) {
      return false
    }
    if (isMobile && this.isVisibleChattingModal) {
      return false
    }

    return true
  }

  @action
  addChatMessage(chatMessage: Schema$ChatMessage) {
    if (this.isShowNewMessageForToastAlert(chatMessage)) {
      message.info(this.makePreviewChatMessage(chatMessage))
    }

    this.newChatMessage = chatMessage

    if (!this.isVisibleChatContent && chatMessage.type === ChatMessageType.CHEER_FOR_TEAM) {
      this.setChatMessageIdOnChatClosed(chatMessage.id)
    }

    this.checkChatMessageListSizeLimit(CHAT_TAB_INDEX.ALL)
    this.allChatMessageList = _.concat(this.allChatMessageList, [chatMessage])

    if ((!_.isEmpty(chatMessage.toUserId) && chatMessage.fromUserId === authStore?.userInfo.id)
      || chatMessage.toUserId === authStore?.userInfo.id) {
      this.checkChatMessageListSizeLimit(CHAT_TAB_INDEX.RECEIVED_MESSAGE)
      this.replyChatMessageList = [].concat(this.replyChatMessageList, [chatMessage])
    }

    if ((chatMessage.type === ChatMessageType.BET_HISTORY || chatMessage.cheerForTeamContentsType === CHEER_FOR_TEAM_CONTENTS_TYPE.BET_HISTORY)
      && !_.isEmpty(chatMessage.attachment)) {
      this.checkChatMessageListSizeLimit(CHAT_TAB_INDEX.SHARED_BET_HISTORY)
      this.shardBetHistoryChatMessageList = [].concat(this.shardBetHistoryChatMessageList, [chatMessage])
    }
    if (chatMessage.type === ChatMessageType.USER_PICK) {
      userPickStore.setLastBestUserPickId(Number(chatMessage.attachment))
    }

    if (!_.isEmpty(chatMessage.activityInfoList)) {
      chatMessage.activityInfoList.forEach(userActivityInfo => {
        if (userActivityInfo.activityType === USER_ACTIVITY_TYPE.CHEER_FOR_TEAM && userActivityInfo.thisActivityScore > 0) {
          userStore.setCheerForTeamUserActivityScoreLastTime(userActivityInfo.activityScoreReceivedTime)
        }
        globalStore.addActivityScoreNoticeQueue(userActivityInfo)
      })
    }
  }

  @action
  checkChatMessageListSizeLimit(tabIndex: CHAT_TAB_INDEX) {
    switch (tabIndex) {
      case CHAT_TAB_INDEX.ALL:
        if (_.size(this.allChatMessageList) >= this.chatMessageTotalLimit) {
          this.originalAllChatMessageList = []
          this.allChatMessageList = [].concat(this.allChatMessageList.splice(_.size(this.allChatMessageList) - this.chatMessageTotalLimit + 1))
        }
        break
      case CHAT_TAB_INDEX.RECEIVED_MESSAGE:
        if (_.size(this.replyChatMessageList) >= this.chatMessageTotalLimit) {
          this.originalReplyChatMessageList = []
          this.replyChatMessageList = [].concat(this.replyChatMessageList.splice(_.size(this.replyChatMessageList) - this.chatMessageTotalLimit + 1))
        }
        break
      case CHAT_TAB_INDEX.SHARED_BET_HISTORY:
        if (_.size(this.shardBetHistoryChatMessageList) >= this.chatMessageTotalLimit) {
          this.originalBetHistoryChatMessageList = []
          this.shardBetHistoryChatMessageList = [].concat(this.shardBetHistoryChatMessageList.splice(_.size(this.shardBetHistoryChatMessageList) - this.chatMessageTotalLimit + 1))
        }
        break
    }
  }

  @action
  async changeChattingModalVisible(isVisible: boolean) {
    if (isVisible) {
      await this.publishVisibleChat()
      this.getRealTimeLiveScoreMatchIdsByBettingHistory()
      globalStore.addVisibleModalList('chattingStore:isVisibleChattingModal')
      lockHtmlOverscroll()
    } else {
      await this.publishInvisibleChat()
      globalStore.removeVisibleModalList('chattingStore:isVisibleChattingModal')
      unlockHtmlOverscroll()
    }

    runInAction(() => {
      this.chatAreaScrolledToBottom = {
        [CHAT_TAB_INDEX_KEY.ALL]: true,
        [CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE]: true,
        [CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY]: true,
      }

      this.isVisibleChattingModal = isVisible
      this.isVisibleChatContent = isVisible

      this.setupSimpleLiveMatchSubscription(!isVisible)
    })
  }

  @action
  changeChattingTabState(tabKey: CHAT_TAB_INDEX_KEY) {
    this.currentTabIndexKey = tabKey
  }

  @action
  setSelectedEmoticon(emoticonUrl: string) {
    this.selectedEmoticonUrl = emoticonUrl
  }

  @action
  setReplyToUser(replyToUser: SimpleChatUserInfo) {
    this.replyToUser = replyToUser
  }

  @action
  setVisibleReplyPopoverKey(popoverKey: string) {
    this.visibleReplyPopoverKey = popoverKey
  }

  @action
  setChatAreaScrolledToBottom(chatTabIndexKey: CHAT_TAB_INDEX_KEY, scrolledToBottom: boolean) {
    this.chatAreaScrolledToBottom[chatTabIndexKey] = scrolledToBottom
    if (scrolledToBottom) {
      this.chatMessageSending = false
      this.newChatMessage = null
    }
  }

  isChatAreaScrolledToBottom() {
    return this.chatAreaScrolledToBottom[this.currentTabIndexKey]
  }

  @action
  updateChatAreaAfterScrollToBottom() {
    clearTimeout(this.updateChatAreaScrollTimer)
    this.updateChatAreaScrollTimer = setTimeout(() => {
      const element = document.querySelector(`#chatList_${this.currentTabIndexKey}`)?.parentElement
      if (element) {
        const { scrollHeight } = element
        element.scrollTo(0, scrollHeight + 1)
      }
    }, 400)
  }

  @action
  setDelayChatAreaScrollToBottom(delay: number = 200) {
    clearTimeout(this.chatAreaScrollToBottomTimer)
    this.chatAreaScrollToBottomTimer = setTimeout(() => {
      document.querySelector(`#chatList_${this.currentTabIndexKey}`)?.parentElement.scrollTo(0, 1000000)
      this.updateChatAreaAfterScrollToBottom()

      runInAction(() => {
        this.chatAreaScrolledToBottom[this.currentTabIndexKey] = true
        this.chatMessageSending = false
        this.newChatMessage = null
      })
    }, delay)
  }

  @action
  async addBlockUser(targetUserInfo: SimpleChatUserInfo, fromUserInfo: SimpleChatUserInfo) {
    await this.api.user.updateChatBlockOrFavoriteUser({ targetUserInfo, fromUserInfo, isBlocking: true, isAdd: true })
    await authStore.refreshUserChatOption(true)
    this.userChatOptions = authStore.userInfo.chatOption
    this.parsingFavoriteAndBlockUserList()
  }

  @action
  parsingFavoriteAndBlockUserList() {
    if (!_.isNil(this.userChatOptions)) {
      this.favoriteUserListObject = _.isNil(this.userChatOptions.favoriteUserList) ? [] : JSON.parse(this.userChatOptions.favoriteUserList)
      this.blockUserListObject = _.isNil(this.userChatOptions.blockUserList) ? [] : JSON.parse(this.userChatOptions.blockUserList)
    }
  }

  @action
  async removeBlockUser(targetUserInfo: SimpleChatUserInfo) {
    await this.api.user.updateChatBlockOrFavoriteUser({ targetUserInfo, isBlocking: true, isAdd: false })
    await authStore.refreshUserChatOption(true)
  }

  @action
  async addFavoriteUser(targetUserInfo: SimpleChatUserInfo, fromUserInfo: SimpleChatUserInfo) {
    await this.api.user.updateChatBlockOrFavoriteUser({ targetUserInfo, fromUserInfo, isBlocking: false, isAdd: true })
    await authStore.refreshUserChatOption(true)
  }

  @action
  async removeFavoriteUser(targetUserInfo: SimpleChatUserInfo) {
    await this.api.user.updateChatBlockOrFavoriteUser({ targetUserInfo, isBlocking: false, isAdd: false })
    await authStore.refreshUserChatOption(true)
  }

  @action
  async publishVisibleChat() {
    if (!authStore.isSignedIn || !this.visibleUserInfo) {
      return
    }

    console.info(`[ChattingStore] publishVisibleChat send: ${JSON.stringify(this.visibleUserInfo)}`)
    await this.checkChatSocketConnectionState()
    this.chatSocket.emit(CHAT_SOCKET_EVENT.VISIBLE_CHAT, this.visibleUserInfo)
  }

  @action
  async publishInvisibleChat() {
    if (!authStore.isSignedIn || !this.visibleUserInfo) {
      return
    }

    console.info(`[ChattingStore] publishInvisibleChat send: ${JSON.stringify(this.visibleUserInfo)}`)
    await this.checkChatSocketConnectionState()
    this.chatSocket.emit(CHAT_SOCKET_EVENT.INVISIBLE_CHAT, this.visibleUserInfo)
  }

  makePreviewChatMessage(chatMessage: Schema$ChatMessage) {
    const {
      fromUserNick, type: chatType, contents, filteredContents,
      cheerForTeamContentsType,
    } = chatMessage

    if (chatType === ChatMessageType.IMAGE || cheerForTeamContentsType === CHEER_FOR_TEAM_CONTENTS_TYPE.IMAGE) {
      return `${fromUserNick} : 이미지를 보냈습니다.`
    }
    if (chatType === ChatMessageType.EMOTICON || cheerForTeamContentsType === CHEER_FOR_TEAM_CONTENTS_TYPE.EMOTICON) {
      return `${fromUserNick} : 이모티콘을 보냈습니다.`
    }
    if (chatType === ChatMessageType.BET_HISTORY || cheerForTeamContentsType === CHEER_FOR_TEAM_CONTENTS_TYPE.BET_HISTORY) {
      return `${fromUserNick} : 베팅내역을 보냈습니다.`
    }
    if (chatType === ChatMessageType.USER_PICK) {
      return `${fromUserNick} : 오늘의 승부사`
    }

    return `${fromUserNick} : ${filteredContents || contents}`
  }

  getDeletedTimelineMatchIdListByUser(): number[] {
    const timelineMatchData = StorageUtils.getDeletedTimelineMatchIdList()
    const userId = authStore.userInfo.id
    return timelineMatchData?.[userId] ?? []
  }

  getRegisteredTimelineMatchIdListByUser(): number[] {
    let targetTimelineList = this.registeredMatchTimelineList

    if (_.isEmpty(this.registeredMatchTimelineList)) {
      const timelineListMap = StorageUtils.getTimelineMatchIdList()
      targetTimelineList = timelineListMap?.[authStore.userInfo.id] || []
    }

    const matchIds: number[] = []
    _.forEach(targetTimelineList, timeline => {
      const matchId = timeline?.matchTimeline?.matchId
      if (!_.isNil(matchId)) {
        matchIds.push(matchId)
      }
    })
    return matchIds
  }

  existRegisteredTimelineMatchIdByUser(matchId: number): boolean {
    const matchIds = this.getRegisteredTimelineMatchIdListByUser()
    return _.includes(matchIds, matchId)
  }

  getRegisteredTimelineByMatchId(matchId: number): RegisteredMatchTimelineData {
    return _.find(this.registeredMatchTimelineList,
      timeline => {
        return timeline?.matchTimeline?.matchId === matchId
      })
  }

  getLiveMatchTimeLineMatchIdAndTimelineMap(): { [key: number]: SimpleMatchTimeline } {
    const timelineMap = {}
    _.chain(this.liveMatchTimelineGroupList)
      .flatMap<SimpleMatchTimeline>('simpleMatchTimelineList')
      .forEach(timeline => {
        timelineMap[timeline.matchId] = timeline
      }).value()
    return timelineMap
  }

  deleteExpiredEndedMatches() {
    const expireTime = _.toNumber(
      globalStore.findGlobalSetting(GlobalStoreKey.REAL_TIME_SCORE_ENDED_MATCH_EXPIRE_TIME)?.value ?? 1,
    )

    _.forEach(this.registeredMatchTimelineList, registered => {
      const timeline = registered.matchTimeline
      if (_.isEmpty(timeline)) {
        return
      }

      if (timeline.matchStatusCode === MATCH_STATUS.Ended
        || timeline.statusCode === MATCH_GAME_STATUS.Closed) {
        const deletableEndedAt = dayjs(timeline.matchEndedAt).add(expireTime, 'minutes').toDate()
        const now = dayjs().toDate()
        if (now > deletableEndedAt) {
          this.deleteRegisteredMatchTimelineData(timeline.matchId, registered.showFullTime, true)
        }
      }
    })
  }

  getRealTimeLiveScoreMatchIdsByBettingHistory() {
    if (!authStore.isSignedIn || !this.visibleUserInfo) {
      return
    }

    const deletedMatchIds = this.getDeletedTimelineMatchIdListByUser()
    const registeredMatchIds = this.getRegisteredTimelineMatchIdListByUser()
    const withoutMatchIds = _.concat(deletedMatchIds, registeredMatchIds)

    portalSocketStore.socket.emit(PORTAL_SOCKET_EVENT.GET_REALTIME_LIVE_SCORE_MATCH_IDS_BY_BETTING_HISTORY,
      { withoutMatchIds, userPromiseId: authStore.userInfo.id },
    )
  }

  async onRealTimeLiveScoreMatchIdsByBettingHistory(matchIds: number[]): Promise<void> {
    if (_.isEmpty(matchIds)) {
      return
    }

    if (_.isEmpty(this.liveMatchTimelineGroupList)) {
      this.matchIdListToAdd = _.concat(this.matchIdListToAdd, matchIds)
    } else {
      _.forEach(matchIds, matchId => {
        this.registerMatchTimelineWatchingListByBettingHistory(matchId)
      })
    }
  }


  @action
  removeChatMessagesByUserPromiseIds(userPromiseIds: string[]) {
    const blockMessageFilter = (chatMessages: Schema$ChatMessage[]) => {
      return _.filter(
        chatMessages,
          chatMessage => !_.includes(userPromiseIds, chatMessage.fromUserId)
      )
    }

    this.allChatMessageList = _.concat([], blockMessageFilter(this.allChatMessageList))
    this.replyChatMessageList = _.concat([], blockMessageFilter(this.replyChatMessageList))
    this.shardBetHistoryChatMessageList = _.concat([], blockMessageFilter(this.shardBetHistoryChatMessageList))

    this.originalChatMessageList = _.concat([], blockMessageFilter(this.originalChatMessageList))
    this.originalAllChatMessageList = _.concat([], blockMessageFilter(this.originalAllChatMessageList))
    this.originalReplyChatMessageList = _.concat([], blockMessageFilter(this.originalReplyChatMessageList))
    this.originalBetHistoryChatMessageList = _.concat([], blockMessageFilter(this.originalBetHistoryChatMessageList))
  }

  @action
  resetChatBlockUserIds() {
    this.setChatBlockUserIds([])
  }

  @action
  setChatBlockUserIds(userPromiseIds: string[]) {
    this.chatBlockUserIds = _.concat([], userPromiseIds)
  }

  @action
  addChatBlockUserId(userPromiseId: string) {
    if (_.includes(this.chatBlockUserIds, userPromiseId)) {
      return
    }
    const newChatBlockUserIds = _.concat(this.chatBlockUserIds, [ userPromiseId ])
    this.setChatBlockUserIds(newChatBlockUserIds)
    this.removeChatMessagesByUserPromiseIds([userPromiseId])
  }

  @action
  removeChatBlockUserId(userPromiseId: string) {
    if (!_.includes(this.chatBlockUserIds, userPromiseId)) {
      return
    }
    const newChatBlockUserIds = _.concat([], this.chatBlockUserIds)
    _.remove(newChatBlockUserIds, blockUserId => blockUserId === userPromiseId)
    this.setChatBlockUserIds(newChatBlockUserIds)
  }

  @action
  async fetchChatBlockUserIds() {
    try {
      const { userPromiseIds } = await this.api.chat.getChatBlockUserInfos()

      if (!_.isEmpty(userPromiseIds)) {
        this.setChatBlockUserIds(userPromiseIds)
      }
    } catch (err) {
      console.error(err)
    }
  }

  @action
  resetCheerForTeamListData(resetAll = false): void {
    this.cheerForTeamMatchList = []
    this.cheerForTeamMatchListPageNum = 1
    this.cheerForTeamMatchListHasMore = false
    if (resetAll) {
      this.cheerForTeamMatchTotalCountPerTab = {
        myBet: 0, favorite: 0, live: 0,
      }
      this.setCurrentCheerForTeamType(CHEER_FOR_TEAM_MATCH_TYPE.MY_BET)
      this.setCurrentCheerForTeamSubType(CHEER_FOR_TEAM_MATCH_SUB_TYPE.ONGOING)
    }
  }

  @action
  async fetchCheerForTeamMatchList(params: {
    cheerForTeamType: CHEER_FOR_TEAM_MATCH_TYPE, cheerForTeamSubType: CHEER_FOR_TEAM_MATCH_SUB_TYPE,
    autoSwitchMainType: boolean, autoSwitchSubType: boolean, reset?: boolean, resetAll?: boolean,
  }): Promise<void> {
    const {
      cheerForTeamType, cheerForTeamSubType,
      autoSwitchMainType, autoSwitchSubType, reset = false, resetAll = false,
    } = params
    try {
      if (reset || resetAll) {
        this.resetCheerForTeamListData(resetAll)
      }
      const params: IGetCheerForTeamMatchList.Params = {
        cheerForTeamType,
        cheerForTeamSubType,
        autoSwitchMainType,
        autoSwitchSubType,
        pageNum: this.cheerForTeamMatchListPageNum,
        limit: 20,
      }
      const response = await this.api.chat.getCheerForTeamMatchList(params)
      const {
        items, hasMore, myBetTotalCount, favoriteTotalCount, liveTotalCount,
        currentMatchListType, currentMatchListSubType,
      } = response
      runInAction(() => {
        this.cheerForTeamMatchList = this.cheerForTeamMatchList.concat(items)
        this.cheerForTeamMatchTotalCountPerTab = {
          myBet: myBetTotalCount,
          favorite: favoriteTotalCount,
          live: liveTotalCount,
        }
        this.cheerForTeamMatchListHasMore = hasMore
        if (hasMore) {
          this.cheerForTeamMatchListPageNum += 1
        }
        if (autoSwitchMainType && this.currentCheerForTeamType !== currentMatchListType) {
          this.setCurrentCheerForTeamType(currentMatchListType)
        }
        if (autoSwitchSubType && this.currentCheerForTeamSubType !== currentMatchListSubType) {
          this.setCurrentCheerForTeamSubType(currentMatchListSubType)
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setCurrentCheerForTeamType(selectedCheerForTeamType: CHEER_FOR_TEAM_MATCH_TYPE): void {
    this.currentCheerForTeamType = selectedCheerForTeamType
  }

  @action
  setCurrentCheerForTeamSubType(selectedCheerForTeamSubType: CHEER_FOR_TEAM_MATCH_SUB_TYPE): void {
    this.currentCheerForTeamSubType = selectedCheerForTeamSubType
  }

  @action
  setSelectedCheerForTeamItem(item: Schema$CheerForTeamData): void {
    if (this.chattingOptions.activeCheerForTeam) {
      this.selectedCheerForTeamItem = item
    } else {
      this.selectedCheerForTeamItem = null
    }
  }

  @action
  updateSelectedCheerForTeamItemEffectUrl(url: string): void {
    if (this.selectedCheerForTeamItem != null) {
      this.selectedCheerForTeamItem.effectIconUrl = url
    }
  }

  @action
  updateCheerForTeamMatchFavorite(isFavoriteMatch: boolean, matchId: number): void {
    if (!_.isEmpty(this.cheerForTeamMatchList)) {
      const item = _.find(this.cheerForTeamMatchList, { matchId })
      if (item) {
        item.isFavoriteMatch = isFavoriteMatch
      }
    }

    if (isFavoriteMatch) {
      this.cheerForTeamMatchTotalCountPerTab = {
        ...this.cheerForTeamMatchTotalCountPerTab,
        favorite: this.cheerForTeamMatchTotalCountPerTab.favorite + 1,
      }
      matchupStore.increaseFavoriteTotalPreMatchCount()
    } else {
      if (this.cheerForTeamMatchTotalCountPerTab.favorite > 0) {
        this.cheerForTeamMatchTotalCountPerTab = {
          ...this.cheerForTeamMatchTotalCountPerTab,
          favorite: this.cheerForTeamMatchTotalCountPerTab.favorite - 1,
        }
      }
      matchupStore.decreaseFavoriteTotalPreMatchCount()
    }

    matchupStore.updateIsFavoritePreMatchInTournamentTracks(matchId, isFavoriteMatch)

    if (Number(matchupStore.majorUniqueID) === EXCEPTIONAL_UNIQUE_ID.FAVORITE_MATCH) {
      // 분석글 팝업에서 찜을 해제 후 팝업을 닫지 않고 다시 찜을 누르면 찜매치 목록이 갱신되어야 하기 때문에.
      matchupStore.fetchTournamentTracks({
        limit: 20, reset: true, pageType: matchupStore.pageType,
      }).catch(err => console.error(err))
    }
  }

  @action
  removeCheerForTeamMatch(matchId: number): void {
    if (!_.isEmpty(this.cheerForTeamMatchList)) {
      _.remove(this.cheerForTeamMatchList, { matchId })
      this.cheerForTeamMatchList = [].concat(this.cheerForTeamMatchList)
    }
  }

  @action
  async getCheerForTeamMatchInfo(matchId: number): Promise<Schema$CheerForTeamData> {
    try {
      const response = await this.api.chat.getCheerForTeamMatchInfo({ matchId })
      return response.item
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setMySharedBettingHistoryChatMessages(messages: Schema$ChatMessage[]): void {
    this.mySharedBetHistoryChatMessage = messages
  }

  @action
  setVisibleCheerForTeamPanel(isVisible: boolean): void {
    this.isVisibleCheerForTeamPanel = isVisible
  }

  @action
  setCheerForTeamFirstSearch(isFirstSearch: boolean): void {
    this.isCheerForTeamFirstSearch = isFirstSearch
  }

  setChatMessageIdOnChatClosed(chatId: number): void {
    this.chatMessageIdOnChatClosed = chatId
  }

  addMyRecentChat(chat: Schema$ChatMessage): void {
    if (chat.fromUserId !== authStore.userInfo?.id) {
      return
    }

    if (_.size(this.myRecentChatQueue) >= 50) {
      this.myRecentChatQueue.splice(0, 1)
    }

    this.myRecentChatQueue.push(chat)
  }

  checkChatFlood(): boolean {
    const options = globalStore.getChatFloodOptions() as ChatFloodControlOptions

    if (!options || !options.enabled) {
      return false
    }

    if (globalStore.isChatFloodExcludeUser(authStore.accountInfo?.userNum)) {
      return false
    }

    const windowTime = options?.windowTime || 100
    const penaltyThresholdCount = options?.penaltyThresholdCount || 10

    const windowMs = windowTime * 1000

    const chats = _.filter(this.myRecentChatQueue, (chat: Schema$ChatMessage) => {
      if (!options.lastUpdatedAt || dayjs(chat.createdAt).isBefore(options.lastUpdatedAt)) {
         return false
      }

      const chatTime = dayjs(chat.createdAt).valueOf()
      const diffTime = dayjs().valueOf() - chatTime

      return diffTime <= windowMs
    })

    return _.size(chats) >= penaltyThresholdCount
  }
}

export default new ChattingStore()
